import { render, staticRenderFns } from "./SubmissionsReviewTableCell.vue?vue&type=template&id=33343641&scoped=true&"
import script from "./SubmissionsReviewTableCell.vue?vue&type=script&lang=js&"
export * from "./SubmissionsReviewTableCell.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionsReviewTableCell.vue?vue&type=style&index=0&id=33343641&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33343641",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
